import { createAction } from 'redux-actions'
import AuthService from '../../services/AuthService'
import types from './types'

const service = new AuthService()

export const updateUser = createAction(types.USER_UPDATED)

export const hideSignIn = createAction(types.SIGN_IN_HIDE)
export const showSignIn = createAction(types.SIGN_IN_SHOW)

export const signInAnonymously = createAction(types.SIGN_IN, () =>
	service.signInAnonymously()
)

export const signInWithFacebook = createAction(types.SIGN_IN, () =>
	service.signInWithFacebook()
)

export const signInWithGoogle = createAction(types.SIGN_IN, () =>
	service.signInWithGoogle()
)

export const signOut = createAction(types.SIGN_OUT, () =>
	service.signOut()
)

export const getRedirectResult = createAction(types.SIGN_IN_RESULT, () =>
	service.getRedirectResult()
)

export const listenToAuth = () => (
	(dispatch) => {
		service.listenToAuth((user) => {
			if (user) {
				dispatch(updateUser(user))
			} else {
				dispatch(updateUser(null))
			}
		})
	}
)



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js